import { css } from 'twind/css'
import { isDark } from '../../../../utils'
import { useTranslation } from 'react-i18next'
import { useTw } from '../../../../utils/Styles'

function getSvg(color: string) {
  if (color.toLowerCase() === '#1e1e31') {
    return `data:image/svg+xml,%3Csvg width='38' height='38' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 163 198'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M84.6224.645297C89.2314 2.48901 91.4718 7.7202 89.6291 12.3295l-9.4517 23.628h52.5486l12.121-30.30469c1.845-4.60929 7.077-6.85123 11.686-5.007513 4.608 1.843713 6.849 7.074903 5.006 11.684203L89.6291 192.105c-1.8427 4.609-7.0741 6.851-11.6831 5.007-4.6112-1.843-6.8517-7.075-5.009-11.684l9.4517-23.628H29.8403L17.719 192.105c-1.8427 4.609-7.0741 6.851-11.68313 5.007-4.61124-1.843-6.851694-7.075-5.009-11.684L72.937 5.65281c1.8449-4.60929 7.0741-6.85123 11.6854-5.007513zM37.0314 143.823h52.5483l14.3823-35.955H51.4134l-14.382 35.955zm88.5036-89.8879l-14.382 35.955H58.6044l14.382-35.955h52.5486z' fill='url(%23a)'/%3E%3Cdefs%3E%3ClinearGradient id='a' x1='81.283' y1='3.15148' x2='81.283' y2='197.758' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FE5818'/%3E%3Cstop offset='1' stop-color='%23F0F'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E`
  }

  return `%3Csvg width='38' height='38' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 163 198'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M84.6224.645297C89.2314 2.48901 91.4718 7.7202 89.6291 12.3295l-9.4517 23.628h52.5486l12.121-30.30469c1.845-4.60929 7.077-6.85123 11.686-5.007513 4.608 1.843713 6.849 7.074903 5.006 11.684203L89.6291 192.105c-1.8427 4.609-7.0741 6.851-11.6831 5.007-4.6112-1.843-6.8517-7.075-5.009-11.684l9.4517-23.628H29.8403L17.719 192.105c-1.8427 4.609-7.0741 6.851-11.68313 5.007-4.61124-1.843-6.851694-7.075-5.009-11.684L72.937 5.65281c1.8449-4.60929 7.0741-6.85123 11.6854-5.007513zM37.0314 143.823h52.5483l14.3823-35.955H51.4134l-14.382 35.955zm88.5036-89.8879l-14.382 35.955H58.6044l14.382-35.955h52.5486z' fill='${
    isDark(color) ? 'white' : '#0D0626'
  }'%3E%3C/path%3E%3C/svg%3E`
}

const wrapper = css`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  transition: transform 0.16s linear 0s, opacity 0.08s linear 0s;
`

const wrapper_visible = css`
  opacity: 1;
  visibility: visible;
  transform: rotate(0deg);
`

const wrapper_invisible = css`
  opacity: 0;
  visibility: hidden;
  transform: rotate(30deg) scale(0);
`

type CloseProps = {
  show: boolean
  dark?: boolean
  onClick: () => void
}
export function Close({ show, dark, onClick }: CloseProps) {
  const tw = useTw()
  return (
    <div
      onClick={onClick}
      className={tw(wrapper, show ? wrapper_visible : wrapper_invisible)}
    >
      <svg
        width="24"
        height="24"
        fill="none"
        stroke={dark ? 'white' : '#0D0626'}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </div>
  )
}

type OpenProps = {
  show: boolean
  color?: string
  background?: string
  onClick: () => void
}
export function Open({ show, color, background, onClick }: OpenProps) {
  const tw = useTw()
  const [t] = useTranslation('common')
  return (
    <div
      onClick={onClick}
      className={tw(wrapper, show ? wrapper_visible : wrapper_invisible)}
    >
      <img
        alt={t('fab.alt')}
        src={background || getSvg(color)}
        className={tw`select-none h-9 w-9 object-contain`}
      />
    </div>
  )
}
